import { ContentAttached, LogoFamilysearch, NoticeWarning } from '@fs/zion-icon/dist/cjs/icons'
import { IconButton, LabelTooltip, Row, Separator, colors, H6 } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ArtifactLink } from '../../../app/Links'
import ImageAttachment from '../attachments/ImageAttachment'
import DmcMoreLess from '../../../common/DmcMoreLess'
import { aTag } from '../../../../util/CssUtil'

export default function ChatMessage({ setFetchingImages, message, showMore, onMoreLessClick }) {
  const { t } = useTranslation()
  return (
    <>
      {message.text ? (
        <DmcMoreLess showMore={showMore} onMoreLessClick={onMoreLessClick}>
          {message.text.startsWith('https://') ? (
            <a css={aTag} href={message.text} target="_blank" rel="noopener noreferrer">
              {message.text}
            </a>
          ) : (
            message.text
          )}
        </DmcMoreLess>
      ) : (
        <>
          {message.messageType === 'deleted' && (
            <div style={{ color: colors.gray70, textDecoration: 'line-through' }}>
              {t('user.messages.messageWasDeleted', 'This message was deleted')}
            </div>
          )}
        </>
      )}
      {message.replyCount && message.replyCount > 0 ? <H6>{`${message.replyCount} replies`}</H6> : null}
      {message.attachments && (
        <>
          <Separator size="nano" />
          <Row>
            {message.attachments.map((attachment) => {
              if (attachment.serviceType === 'artifact_store') {
                return (
                  <ImageAttachment
                    key={`${message.messageId}-${attachment.id}`}
                    attachment={attachment}
                    setFetchingImages={setFetchingImages}
                  />
                )
              }
              if (attachment.serviceType === 'memory_artifact') {
                return (
                  <ArtifactLink key={`${message.messageId}-${attachment.id}`} artifactId={attachment.id}>
                    <Row gutters="nano">
                      <ContentAttached />
                      {attachment.id}
                    </Row>
                  </ArtifactLink>
                )
              }
              if (attachment.serviceType === 'about') {
                return (
                  <IconButton
                    data-testid="about attachment"
                    key={`${message.messageId}-${attachment.filename}`}
                    Icon={LogoFamilysearch}
                    to={attachment.filename}
                    target="_blank"
                  />
                )
              }
              if (attachment.serviceType === 'unknown') {
                return (
                  <LabelTooltip
                    key={`${message.messageId}-${message.text}-unknownAttachment`}
                    target={<NoticeWarning data-testid="unknown chat attachment" color={colors.yellow20} />}
                    label={t('chat.attachment.unknown', 'Unknown attachment type')}
                  />
                )
              }
              return (
                <LabelTooltip
                  key={`${message.messageId}-unsupportedAttachment`}
                  target={<NoticeWarning data-testid="unsupported chat attachment" />}
                  label={t('chat.attachment.unsupported', 'DMC does not yet support this type of attachment')}
                />
              )
            })}
          </Row>
        </>
      )}
    </>
  )
}
